import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let connection_id = useDataValue({
    context: 'app',
    path: 'connection_id',
    viewPath: props.viewPath,
  })

  let connecting = useDataValue({
    context: 'app',
    path: 'connecting',
    viewPath: props.viewPath,
  })

  return {
    variables: { connection_id },
    pause: !connecting,
  }
}
